import React from "react";
import "../styles/allServices.css";

const services = [
    {
        title: "SPA Massage",
        description: "Relax your mind and body with essential oils designed to restore balance and peace.",
        image: "/images/hotstone.jpg",
        priceOptions: [
            { duration: "30min", price: 40 },
            { duration: "60min", price: 65 },
            { duration: "90min", price: 95 },
            { duration: "120min", price: 120 },
        ],
        addons: ["Hot Stone Massage", "Aromatherapy Oils"],
    },
    {
        title: "RMT Massage",
        description: "Professional Registered Massage Therapy.",
        image: "/images/aromatherapy.png",
        priceOptions: [
            { duration: "30min", price: 65 },
            { duration: "45min", price: 90 },
            { duration: "60min", price: 115 },
            { duration: "75min", price: 140 },
            { duration: "90min", price: 165 },
            { duration: "120min", price: 220 },
        ],
    },
    {
        title: "Facial",
        description:
            "Rejuvenate your skin with our specialized facial treatments tailored to your skin type.",
        image: "/images/facial.jpeg",
        priceOptions: [
            { duration: "Deep cleaning facial", price: 100 },
            { duration: "Hydrolifing facial", price: 120 },
        ],
        hst: true
    },
    {
        title: "Osteopathic Massage",
        description:
            "Osteopathy supports the body’s natural healing processes through hands-on techniques that improve circulation, enhance nerve function, and relieve pain.",
        image: "/images/osteopathic.jpeg",
        priceOptions: [
            { duration: "45min", price: 100 },
            { duration: "60min", price: 130 },
            { duration: "75min", price: 155 },
            { duration: "90min", price: 180 },
        ],
    },
    {
        title: "Acupuncture",
        description:
            "Experience the healing benefits of traditional acupuncture for mind and body balance.",
        image: "/images/acupuncture.jpg",
        priceOptions: [
            { duration: "50min", price: 100 },
            { duration: "75min", price: 150 },
        ],
    },
];

const addons = [
    { title: "Hot Stone", price: 15 },
    { title: "Prental massage", price: 15 },
    { title: "Cupping", price: 20 },
    { title: "Aroma oil", price: 15 },
    { title: "Body scrub", price: 15 },
    { title: "Myofacial blade therapy", price: 15 },
];

const AllServices: React.FC = () => {
    return (
        <section id="services" className="services" style={{ paddingTop: "90px" }}>
            <h2 className="section-title">Our Services</h2>
            <hr className="fancy-hr" />

            <div className="services-grid">
                {services.map((service, index) => (
                    <div key={index} className="service-card">
                        <div className="service-image">
                            <img src={service.image} alt={service.title} />
                        </div>
                        <div className="service-text">
                            <h3>{service.title}</h3>
                            <p>{service.description}</p>
                            <div className="service-price-table">
                                {service.priceOptions?.map((s, idx) => (
                                    <div key={idx} className="price-row">
                                        <span className="duration">{s.duration}</span>
                                        <span className="price">${s.price}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {addons.length > 0 && (
                <section className="addons-section">
                    <h2 className="section-title">Add-on Services</h2>
                    <hr className="fancy-hr" />
                    <div className="addons-grid">
                        {addons.map((addon, idx) => (
                            <div key={idx} className="addons-item">
                                <div className="price-row">
                                    <span className="duration">{addon.title}</span>
                                    <span className="price">${addon.price}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>
            )}
        </section>
    );
};

export default AllServices;